import { createContext, useContext } from 'react';

/**
 * Values that change while the invite form is open but don't change its structure. Read by slot
 * content through context, so they never feed the memoized form config.
 */
export type InviteFormRuntime = {
  /** Submit error surfaced above the footer. */
  errorMsg: string;
};

export const InviteFormRuntimeContext = createContext<InviteFormRuntime>({ errorMsg: '' });

export const useInviteFormRuntime = () => useContext(InviteFormRuntimeContext);
